import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import ChainedBackend from "i18next-chained-backend";

const languageImports = {
  tr: "./locales/tr_app.json",
  en: "./locales/en_app.json",
  de: "./locales/de_app.json",
  fr: "./locales/fr_app.json",
  es: "./locales/es_app.json",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(ChainedBackend)
  .init({
    fallbackLng: "tr",
    supportedLngs: ["tr", "en", "de", "fr", "es"],
    ns: ["app", "error"],
    nsSeparator: ":::",
    defaultNS: "app",
    preload: ["tr", "en", "de", "fr", "es"],
    backend: {
      backends: [
        HttpBackend,
        resourcesToBackend((language, namespace, callback) => {
          if (
            languageImports[language as keyof typeof languageImports] &&
            namespace === "app"
          ) {
            import(`./locales/${language}_${namespace}.json`)
              .then(({ default: data }) => {
                callback(null, data);
              })
              .catch(() => {
                import(`./locales/tr_app.json`).then(({ default: data }) => {
                  callback(null, data);
                });
              });
          } else {
            import(`./locales/tr_app.json`).then(({ default: data }) => {
              callback(null, data);
            });
          }
        }),
      ],
      backendOptions: [
        {
          loadPath:
            "https://fal-kling-videos.s3.us-east-1.amazonaws.com/translations/{{lng}}_{{ns}}.json",
        },
      ],
    },
    detection: {
      order: ["localStorage", "navigator"],
      convertDetectedLanguage: (lng) => {
        // Convert en-US to en, tr-TR to tr, de-DE to de etc.
        return lng.split("-")[0];
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
